export default __webpack_public_path__ + "assets/407a7e1d524e2c60de44089ab8ffc90f.png";